import React from 'react';
import { Box, ButtonBase, Dialog, IconButton, Typography } from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { baseCassConfirm } from '../../../../BedStatus/components/PopWindows/baseCss';

export default function ReastPop({ closePop, open, confirmClick }) {
  const baseClasses = baseCassConfirm();

  const confirmHandler = () => {
    closePop();
    confirmClick();
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '2.187rem 0 1.562rem' }}>
          <Typography className={baseClasses.headerTitle}>{i18n.t('SETTING_RESET_WARD')}</Typography>
          <IconButton id="setting_pop_close_resetward" className={baseClasses.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <Typography className={baseClasses.areYouSureYouWou}>
          {i18n.t('SETTING_ARE_YOU_SURE_YOU_WOULD_LIKE_TO_RESET_THE_SETUP')}
        </Typography>
        <Box display="flex" justifyContent="center" style={{ margin: '7rem 0 2.375rem 0' }}>
          <ButtonBase
            id="setting_pop_resetward_btn1"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('SETTING_CANCEL')}
          </ButtonBase>
          <ButtonBase id="setting_pop_resetward_btn2" className={baseClasses.configBtn} onClick={confirmHandler}>
            {i18n.t('SETTING_CONFIRM')}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
